import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const BASE_URL = environment.base_url_second;
const base_url = environment.base_url;

@Injectable({
    providedIn: 'root'
})
export class AccountSettingService {

    constructor(private http: HttpClient) { }

    getAllAddress() {
        const url = `${BASE_URL}/address`;
        return this.http.get(url).pipe(
            map((resp) => resp)
        )
    }

    addAddress(formJson) {
        const url = `${BASE_URL}/address`;
        return this.http.post(url, formJson);
    }

    deleteAddress(formId: string) {
        const url = `${BASE_URL}/address/${formId}`;
        return this.http.delete(url);
    }

    connectAccount(countryCode: string) {
        const url = `${base_url}/connectLink?countryCode=${countryCode}`;
        return this.http.get(url);
    }

}
